'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgMinimizeScreen(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M7.138 2.403c-.492 0-.853.353-.853.846v.181l.147 1.841-1.23-1.307-1.692-1.71A.818.818 0 002.903 2C2.378 2 2 2.37 2 2.896c0 .238.099.452.263.616l1.699 1.693 1.313 1.233-1.863-.148h-.238a.829.829 0 00-.854.855c0 .493.361.855.854.855h3.455C7.5 8 8 7.499 8 6.627V3.25c0-.485-.37-.846-.862-.846zM12.826 8H9.371C8.5 8 8 8.501 8 9.373v3.378c0 .485.37.846.862.846.484 0 .853-.353.853-.846v-.173l-.155-1.85 1.23 1.316 1.7 1.71c.156.164.37.246.607.246.525 0 .903-.362.903-.896a.86.86 0 00-.263-.608l-1.699-1.701-1.321-1.225 1.863.148h.246a.829.829 0 00.854-.855c0-.501-.361-.863-.854-.863z", fill: "currentColor" }))));
}

module.exports = SvgMinimizeScreen;
//# sourceMappingURL=MinimizeScreen.js.map
